module.exports = __webpack_public_path__ + "img/img12.0e6b57d0.png";